import Cookies from 'js-cookie';
import './src/styles/__base.scss';
import { isBrowser } from './src/utils/ssr';
import { initAxios } from './src/utils/api';
import { initFaceItAxios } from './src/utils/faceItApi';
import { LOCALE_COOKIE_NAME } from './src/utils/locale';

export const onClientEntry = () => {
	if (isBrowser) {
		initAxios(process.env.GATSBY_API_URL, {});
		initFaceItAxios(process.env.GATSBY_FACEIT_API_URL, {});
	}
};

export const onRouteUpdate = () => {
	if (!isBrowser) return;

	const locale = window.localStorage.getItem(LOCALE_COOKIE_NAME);
	if (locale) {
		Cookies.set(LOCALE_COOKIE_NAME, locale, { expires: 365, path: '/' });
	}
};
